// Customer related endpoints
export const customerEndpoints = (builder) => ({
  // Customer CRUD operations
  // getCustomers: builder.query({
  //   query: (payload) => ({
  //     url: '/common/get-customer',
  //     method: 'POST',
  //     body: payload,
  //   }),
  //   providesTags: ['Customer'],
  // }),

  getCustomers: builder.query({
    query: (args = {}) => {
      const {
        pageNumber = 1,
        pageSize = 10,
        searchTerm,
        searchValue,
        sortBy,         // optional: 'FullName' for dropdown, undefined for list view
      } = args;

      const params = {
        pageNumber,
        pageSize,
      };

      // Add searchTerm and searchValue only if they are defined and not null
      if (searchTerm !== null && searchTerm !== undefined) {
        params.searchTerm = searchTerm;
      }
      if (searchValue !== null && searchValue !== undefined) {
        params.searchValue = searchValue;
      }
      // Only include sortBy when explicitly requested (e.g. from dropdown)
      if (sortBy !== null && sortBy !== undefined) {
        params.sortBy = sortBy;
      }

      return {
        url: '/common/get-customer',
        method: 'GET',
        params,
      };
    },
    providesTags: ['Customer'],
  }),

  getCustomersWithoutArea: builder.query({
    query: (args = {}) => {
      const {
        pageNumber = 1,
        pageSize = 10,
        searchTerm,
        searchValue,
      } = args;

      const params = {
        pageNumber,
        pageSize,
      };

      if (searchTerm !== null && searchTerm !== undefined) {
        params.searchTerm = searchTerm;
      }
      if (searchValue !== null && searchValue !== undefined) {
        params.searchValue = searchValue;
      }

      return {
        url: '/common/get-customers-without-area',
        method: 'GET',
        params,
      };
    },
    providesTags: ['Customer'],
  }),

  // Search customers (POST) - used by Customer Browser UI
  searchCustomers: builder.mutation({
    query: (payload) => ({
      url: '/common/search-customer',
      method: 'POST',
      body: payload,
    }),
    // do not automatically provide tags; this is a search request
  }),

  getCustomerById: builder.query({
    query: (id) => ({
      url: `/common/get-customerById/${id}`,
      method: 'GET',
    }),
    providesTags: (result, error, id) => [{ type: 'Customer', id }],
  }),

  saveCustomer: builder.mutation({
    query: (data) => ({
      url: '/common/save-customer',
      method: 'POST',
      body: data,
    }),
    invalidatesTags: ['Customer'],
  }),

  deleteCustomer: builder.mutation({
    query: (id) => ({
      url: `/common/delete-Customer/${id}`,
      method: 'DELETE',
    }),
    invalidatesTags: ['Customer'],
  }),

  bulkDeleteCustomers: builder.mutation({
    query: (ids) => ({
      url: '/common/bulk-delete-customer',
      method: 'DELETE',
      body: { customerIds: ids },
    }),
    invalidatesTags: ['Customer'],
  }),

  bulkUpdateCustomerArea: builder.mutation({
    query: (payload) => ({
      url: '/common/bulk-update-customer-area',
      method: 'PUT',
      body: payload,
    }),
    invalidatesTags: ['Customer'],
  }),

  saveCustomerBankDetails: builder.mutation({
    query: (payload) => ({
      url: '/common/customer-bank-details',
      method: 'POST',
      body: payload,
    }),
    invalidatesTags: ['Customer', 'Group'],
  }),

  mergeAndDeleteCustomer: builder.mutation({
    query: (payload) => ({
      url: '/common/merge-and-delete-customer',
      method: 'POST',
      body: payload,
    }),
    invalidatesTags: ['Customer', 'Group'],
  }),

  getPincodeDetails: builder.query({
    query: (pincode) => ({
      url: `/common/pincode/${pincode}`,
      method: 'GET',
    }),
  }),
});
